import { render, staticRenderFns } from "./DiyoboInput.vue?vue&type=template&id=57846115&scoped=true"
import script from "./DiyoboInput.vue?vue&type=script&lang=js"
export * from "./DiyoboInput.vue?vue&type=script&lang=js"
import style0 from "./DiyoboInput.vue?vue&type=style&index=0&id=57846115&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57846115",
  null
  
)

export default component.exports